// Utilities to work with the `/data` namespace of our store

import { wrapArray } from "shared/utils/support";

// Reads resource list from data section, (custom list of ids, normally you would use App* version)
function readData(data, resourceName, ids = []) {
  const resourceData = data[resourceName];
  return wrapArray(ids).map(id => resourceData[id]);
}

// Reads single item from data section (custom id, normally you would use App* version)
function readSingleData(data, resourceName, id) {
  return data[resourceName] && data[resourceName][id];
}

// Reads resource list from data section and connects it with the current app's page data
export function readAppData(state, resourceName) {
  const ids = state.app.currentPageData[resourceName];
  return readData(state.data, resourceName, ids);
}

// Reads single item from data section and connects it with the current app's page data
//   The data will always be stored as a list/array, use this function if you wish to have
//   only a single record
export function readSingleAppData(state, resourceName) {
  const ids = state.app.currentPageData[resourceName];
  return ids && readSingleData(state.data, resourceName, ids[0]);
}
